/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../compat/compat.component';
const styles_CompatComponent:any[] = ([] as any[]);
export const RenderType_CompatComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CompatComponent,data:{}});
export function View_CompatComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{entryPoint:0}),(_l()(),i0.ɵted((null as any),
      ['\n    '])),(_l()(),i0.ɵeld(16777216,[[1,3],['entryPoint',1]],(null as any),
      0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n  ']))],(null as any),(null as any));
}
export function View_CompatComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'webapp-compat',
      ([] as any[]),(null as any),(null as any),(null as any),View_CompatComponent_0,
      RenderType_CompatComponent)),i0.ɵdid(114688,(null as any),0,i1.CompatComponent,
      [[1,i0.Injector],i0.NgModuleFactoryLoader],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CompatComponentNgFactory:i0.ComponentFactory<i1.CompatComponent> = i0.ɵccf('webapp-compat',
    i1.CompatComponent,View_CompatComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0LmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQudHMuQ29tcGF0Q29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQuY29tcG9uZW50LnRzLkNvbXBhdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxuZy1jb250YWluZXIgI2VudHJ5UG9pbnQ+PC9uZy1jb250YWluZXI+XG4gICIsIjx3ZWJhcHAtY29tcGF0Pjwvd2ViYXBwLWNvbXBhdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozt3RENBQTtNQUFBLGFBQ0k7TUFBQTtNQUFBLGdCQUF5Qzs7O29CQ0Q3QztNQUFBO2dDQUFBLFVBQUE7TUFBQTs7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/$$_gendir/compat/compat.component.ngfactory.ts